export default "__VITE_ASSET__DKEbV1a0__"